<template>
<div class="chapter">
<div class="inner_page">
<p class="h2"><a id="page_vi"></a><a id="page_vii">Contents</a></p><a id="page_vii">
</a><p class="toc"><a id="page_vii"></a><a href="#/html/07_Acknowledge">Acknowledgments</a></p>
<p class="toc"><a href="#/html/08_Introduction">Introduction</a></p>
<p class="tocp"><a href="#/html/10_Part1">PART I. HISTORY AND THEORY</a></p>
<p class="toc"><a href="#/html/11_chapter1">1. The Art Film</a></p>
<p class="toc"><span href="#/html/12_chapter2" title="Link target outside of Sample">2. Economic Links</span></p>
<p class="toc"><span href="#/html/13_chapter3" title="Link target outside of Sample">3. The Euro-American Art Film: Definition</span></p>
<p class="toc"><span href="#/html/14_chapter4" title="Link target outside of Sample">4. The Euro-American Art Film: History</span></p>
<p class="toc"><span href="#/html/15_chapter5" title="Link target outside of Sample">5. Cultural Dominance or Cultural Mix</span></p>
<p class="tocp"><span href="#/html/16_Part2" title="Link target outside of Sample">PART II. CASE STUDIES</span></p>
<p class="toc"><span href="#/html/16_Part2#intro" title="Link target outside of Sample">Introduction</span></p>
<p class="toc"><span href="#/html/17_chapter6" title="Link target outside of Sample">6. Art and Commerce in <i>Contempt</i></span></p>
<p class="toc"><span href="#/html/18_chapter7" title="Link target outside of Sample">7. <i>Blow-Up</i>, Swinging London, and the Film Generation</span></p>
<p class="toc"><span href="#/html/19_chapter8" title="Link target outside of Sample">8. Pasolini’s <i>The Canterbury Tales</i>: The Estrangement of an English Classic</span></p>
<p class="toc"><span href="#/html/20_chapter9" title="Link target outside of Sample">9. <i>Paris, Texas</i>, an American Dream</span></p>
<p class="toc"><span href="#/html/21_chapter10" title="Link target outside of Sample">10. <i>The Last Emperor:</i> Pleasures and Dangers of the Exotic</span></p>
<p class="toc"><span href="#/html/22_chapter11" title="Link target outside of Sample">11. Final Comments</span></p>
<p class="tocp"><span href="#/html/23_notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/html/24_Film" title="Link target outside of Sample">Filmography: Euro-American Art Films</span></p>
<p class="toc"><span href="#/html/25_Biblio" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/html/26_Index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_content.vue?c8851cdc